import { useState } from "react";

export default function useDotLegalNote() {
    const [showDialog, setShowDialog] = useState(false);

    return { showDialog, setShowDialog };
}
